! (() => {
    const our_menu = document.querySelector('.home-our-menu');
    if (! our_menu) return;

    const buttons = our_menu.querySelectorAll('.btn-group .btn');
    const menuItems = our_menu.querySelectorAll('.item');

    function showAll() {
        menuItems.forEach(item => {
            item.style.display = 'block';
        });
    }

    function filterByCategory(category) {
        menuItems.forEach(item => {
            if (item.dataset.category === category) {
                item.style.display = 'block';
            } else {
                item.style.display = 'none';
            }
        });
    }

    function removeActiveClass() {
        buttons.forEach(button => {
            button.classList.remove('active');
        });
    }

    function addActiveClass(button) {
        button.classList.add('active');
    }

    buttons.forEach(button => {
        button.addEventListener('click', function () {
            const filter = this.dataset.filter;

            removeActiveClass();
            addActiveClass(this);

            if (filter === 'All') {
                showAll();
            } else {
                filterByCategory(filter);
            }
        });
    });
})();